<template>
  <a @click="shareViaWebShare">
    {{ $msg('product.share.button', 'product') }}
  </a>
</template>

<script>
import getAnalyticsEventBus from '../../common/getAnalyticsEventBus';

const analyticsEventBus = getAnalyticsEventBus();

export default {
  name: 'BaseShareProductButton',

  props: {
    productName: {
      type: String,
      required: true,
    },
  },

  computed: {
    urlWithUtm() {
      const { href, search, protocol, hostname, pathname } = window.location;
      const params = new URLSearchParams(search);
      if (params.getAll('utm_source').indexOf('product-share') !== -1) {
        return href;
      }
      params.append('utm_source', 'product-share');
      params.append('utm_medium', 'social');
      return `${protocol}//${hostname}${pathname}?${params.toString()}`;
    },
  },

  methods: {
    shareViaWebShare() {
      navigator.share({
        title: this.$msg('product.share.title', 'product'),
        text: this.productName,
        url: this.urlWithUtm,
      });

      // Send info for Analytics
      analyticsEventBus.publish(
        analyticsEventBus.EVENTS.productDetailsItemClicked,
        analyticsEventBus.EVENTS.PAYLOADS.productDetailsItemClicked.item.share
      );
    },
  },
};
</script>
